import React from "react";
import { useSelector } from "react-redux";
import UsedInLink from "../UsedInLink";
import { selectEventHandlers } from "../../../store/slices/projectSlice";
import UsedInBadge from "../UsedInBadge";
import HelpButton from "../../../HelpContent/HelpButton";

export default function Modules() {
  const eventHandlers = useSelector(selectEventHandlers);

  return (
    <div className="mt-2 card">
      <div className="card-header m-0 p-2">
        <h5 className="card-title">
          Modules
          <HelpButton helpKey="modules" />
        </h5>
      </div>
      <div className="card-body p-0">
        {eventHandlers.filter((eh) => eh.IsModule).length > 0 ? (
          <ul className="list-group list-group-flush">
            {eventHandlers
              .filter((eh) => eh.IsModule)
              .map((eventHandler) => (
                <li key={eventHandler.UUID} className="list-group-item p-2">
                  <div className="d-flex justify-content-between align-items-baseline">
                    <span className="">{eventHandler.Label}</span>
                    <UsedInBadge arg={eventHandler} />
                  </div>
                </li>
              ))}
          </ul>
        ) : (
          <div className="text-center m-1">No modules</div>
        )}
      </div>
    </div>
  );
}
